export const ROUTE_PATHS ={
    home: '/ui',
    login:'login',
    help:'/help',
    table:'/tables',
    inap:'/inap',
    about:'/about',

    download:'/download',
    all_downloads: '/all_dl',
    queued_download: '/queued_dl',

    field_samples:'/field_samples',
    area:'/area/:area_id',
    group:'/group/:group_id',
    sample:'/field_sample/:site_id',
    contacts: '/contacts',
    data_import: '/data_import',
    data_process: '/data_process',
    data_recalc_process: '/data_recalc_process',

    stations:'/stations',
    field_sample_sites: '/field_sample_sites',
    nfdrTable:'fireDanger/:station_id',
    stationMeta:'stationMetaData/:station_id',
    catalog:'catalog/:station_id',
    charts:'charts/:station_id',
    apiKey:'/fems-api-key-gen',

    powerbi:'/reports',
    pbiFireDanger:'/reports/fire-danger',
    pbiWeather:'/reports/weather',
    pbiStationInformation:'/reports/station-information',
    pbiAdvanced:'/reports/advanced',
    pbiFieldSample:'/reports/field-sample',
    report:'/report/',

    catalogs:'/catalogs',
    droughtTab: '/catalogs/drought',
    liveTab: '/catalogs/live',
    deadTab: '/catalogs/dead',
    fuelTab: '/catalogs/fuel',
    fuelCreateUpdate: '/fuel_create_update'

}